import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'

/**
 * Maps an API error body (the parsed server response) to the user-facing message string,
 * reproducing the exact branching the old NewServiceListener PUBLISH_SERVICE_ERROR case used.
 */
export function getNewServiceErrorMessage(body: unknown): string {
  const errorBody = body && typeof body === 'object' ? body : {}

  const rawCode = 'UserFriendlyErrorCode' in errorBody ? errorBody.UserFriendlyErrorCode : undefined
  const userFriendlyErrorCode = typeof rawCode === 'string' || typeof rawCode === 'number' ? rawCode : undefined
  const rawExtra = 'extra' in errorBody ? errorBody.extra : undefined
  const extra = typeof rawExtra === 'string' ? rawExtra : undefined

  if (userFriendlyErrorCode || userFriendlyErrorCode === '') {
    return userFriendlyErrorCode ? getUserFriendlyErrorMessage(userFriendlyErrorCode, null, extra) : ''
  }

  const errorCode = 'ErrorCode' in errorBody ? errorBody.ErrorCode : undefined

  switch (errorCode) {
    case 'NameNotValid':
      return getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Service Type')
    case 'DescriptionNotValid':
      return getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Service description')
    case 'VisitTypeIntakeFormCountNotValid':
      return getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Intake forms')
    case 'VisitTypeCostNotValid':
    case 'VisitTypeNameNotValid':
    case 'VisitTypeCancellationFeeNotValid':
      return getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
    case 'NameNotUnique':
      return getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, 'Service type')
    case 'InternalServerError':
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
    default:
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
  }
}
